











































































import { Component,Model, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";
import { GapTransportationCoordinationReportFilter } from "@/store/modules/types";

@Component({
  components: {
    BPopover,
  },
  computed: mapState("gaps", ["subStatus","reasons"]),
})
export default class StatusFilter extends Vue {
 @Model("change") readonly filter!: GapTransportationCoordinationReportFilter;
  id = "substatus-filter-popover";
  target = "substatus-filter-target";
  subStatus!: Array<any>;
  list = Array<any>();
  reasons!: Array<any>;
  reasonList = Array<any>();
  async checkSubStatus() {
    this.list.forEach((ss) => {
      ss.checked = true;
    });
  }
  async uncheckSubStatus() {
    this.list.forEach((ss) => {
      ss.checked = false;
    });
  }
   async checkReason() {
    this.reasonList.forEach((r) => {
      r.checked = true;
    });
  }
  async uncheckReason() {
    this.reasonList.forEach((r) => {
      r.checked = false;
    });
  }
  get checkedSubStatus(): Array<any> {
    return this.list
      .filter((ss) => {
        return ss.checked;
      })
      .map((ss) => ss.id);
  }
  get checkedReasons(): Array<any> {
    return this.reasonList
      .filter((r) => {
        return r.checked;
      })
      .map((ss) => ss.id);
  }
  search() {
    this.filter.subStatusList = JSON.parse(JSON.stringify(this.checkedSubStatus));
    this.$emit('refresh')
    this.close();
  }
  clear() {
    this.uncheckSubStatus();
    this.uncheckReason();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { subStatusList} =  this.filter;
    this.list = JSON.parse(JSON.stringify(this.subStatus)).map((ss) => {
      ss.checked = subStatusList.includes(ss.id);
      return ss;
    });
  }
}
